import { LoginInfoProvider } from './../../ev-dal/login-info.provider';
import { CollegeDetailService } from './../../services/college-detail.service';
import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
 

@Component({
  selector: 'app-college-list',
  templateUrl: './college-list.component.html',
  styleUrls: ['./college-list.component.scss']
})
export class CollegeListComponent implements OnInit, OnChanges {
  @Input() isShowBtnExport: boolean;
  @Input() collegeJsonList: any[];
  @Input() housingJsonList: any[];
  @Input() statusJsonList: any[];
  @Input() partnerId: any;
  @Input() studentId;
  @Input() studentUserId: any;
  @Input() showPagination = true;
  @Input() totalItems: any;
  @Input() currentPage: any;
  @Input() maxSize: any;
  @Output() onCollegeClick = new EventEmitter();
  @Output() onPaginationSettingsChange = new EventEmitter();
  @Output() onExcelExport = new EventEmitter();
  @Input() filterData; 

  isSenior: Boolean;
  isTiled = true;
  isMobile = false;
  orderByOptions = ['MyFit Score', 'A-Z', 'Z-A', 'Academic', 'Social', 'Majors', 'Financial'];
  optionSelected = 'MyFit Score';
  showDropdowns: Boolean;
  sortedCollegeList: any[];
  pageShow = false;
  selectedCollegeData;
  studentClassYearDescription: boolean;
  showHousingStatusDropDown = false;
  role: string;
  module: string;
  showPin = false;
  myFitHide = false;


  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonDataSharedService: CommonDataSharedService,
    private _commonService: CommonService,
    private routes: ActivatedRoute,
    private router: Router,
    private _collegeDetailService: CollegeDetailService,
    private loginInfoProvider: LoginInfoProvider
  ) { }

  ngOnInit() {
    this.studentIsSenior();
    this.role = this._commonAuthService.getRoleName().toLowerCase();
    this.module = this._commonAuthService.getModule().toLowerCase();
    this.showPin = (this.module.toLowerCase() === 'student' && ['collegeSearch', 'myColleges', 'myFitList'].includes(this.router.url.split('/')[2])) || (this.loginInfoProvider.module.toLowerCase() === 'coach' && this.router.url.split('/')[2] === 'coachStudentDetail');
    if (this.router.url.split('/') && this.router.url.split('/')[2] && ['studentSummary', 'myColleges'].includes(this.router.url.split('/')[2].toString())) {
      this.showHousingStatusDropDown = true;
    } else {
      this.showHousingStatusDropDown = false;
    }
    this.checkDropdownsVisibility();
    this.isMobile = this._commonService.checkDeviceIsMobile();
    
    this.myFitHide = this.module.toLowerCase() === 'coach' && this.router.url === '/coach/collegeSearch';
  }

  ngOnChanges() {
    this.studentIsSenior();
    this.checkDropdownsVisibility();
    this.optionSelected = this.filterData;
  }

  getPercentage(value) {
    return `${parseInt(value)}, 100`;
  }

  optionsSelected(event) {
    if (this.collegeJsonList && this.router.url === '/student/myColleges') {
      this.sortedCollegeList = this.optionSelected === 'A-Z' ? this.collegeJsonList.sort(this.nameSort) :
        this.optionSelected === 'Z-A' ? this.collegeJsonList.sort(this.nameSort).reverse() :
          this.optionSelected === 'MyFit Score' ? this.collegeJsonList.sort(this.rankSort).reverse() :
            this.sortedCollegeList = this.collegeJsonList.sort((a, b) => {
              for (let i = 0; i < a.myFit.length && i < b.myFit.length; i++) {
                if (a.myFit[i].name === this.optionSelected && b.myFit[i].name === this.optionSelected) {
                  return a.myFit[i].value - b.myFit[i].value;
                }
              }
            }).reverse()
    }
    else {

      this._commonDataSharedService.collegesFilter.next(this.optionSelected)

    }
  }
  studentIsSenior() {
    const localClassYearDescription = JSON.parse(localStorage.getItem('classYearDescription'));
    this.studentClassYearDescription = localClassYearDescription === 'Senior';
  }

  showRank(scores: any[]) {
    return scores.filter(item => item.name === 'Composite')[0].value || '0';
  }

  pinColleges(item, i) {
    this._collegeDetailService.setCollegePin(item.collegeid, this.studentId)
      .subscribe(
        () => {
          this.notificationService.show('success', 'College pinned successfully!');
          if (this.sortedCollegeList && this.sortedCollegeList[i]) {
            this.sortedCollegeList[i].pinned = !this.sortedCollegeList[i].pinned
          }
          this._commonDataSharedService.pinCollege.next();
        });
  }

  unPinColleges(item, i) {

    this._collegeDetailService.removeCollegePin(item.collegeid, this.studentId)
      .subscribe(
        () => {
          this.notificationService.show('success', 'College unpinned successfully!');
          if (this.sortedCollegeList && this.sortedCollegeList[i]) {
            this.sortedCollegeList[i].pinned = !this.sortedCollegeList[i].pinned
          }
          this._commonDataSharedService.unpinCollege.next();
        });
  }


  favorCollege(college, index) {
    (college && college.pinned) ? this.unPinColleges(college, index) : this.pinColleges(college, index);
  }

  setPage(pageNo: number) {
    this.currentPage = pageNo;
  };

  pageChanged(event: any) {
    const obj = { pageNumber: this.currentPage, pageSize: this.maxSize };
    this._commonDataSharedService.collegeListPageChange.next(obj);
  };

  updatePaginationSettings() {
    this.onPaginationSettingsChange.emit({
      maxSize: this.maxSize,
      currentPage: this.currentPage
    });
  }

  updateCollege(college, item) {
    const inputJson = {
      studentUserId: college.studentUserId,
      collegeId: college.collegeid,
      housingPlanClassId: college.housingPlanClassId,
      applicationStatusClassId: college.applicationStatusClassId,
      attainabilityClassId: college.attainabilityClassId,
    };

    this._commonRequestResponseService.putWithHeader('student/myColleges', inputJson)
      .subscribe(
        () => {
          this.notificationService.show('success', 'College updated successfully');
          this._commonDataSharedService.checkPinUnpinCollege.next(true);
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  setCollegeData(item) {
    if (this.module.toLowerCase() === 'parent') {
      this.onCollegeClick.emit(item);
      return;
    }
    window.scrollTo(0, 0);
    const obj = { collegeData: item.collegeid };
    localStorage.setItem('collegeIdData', JSON.stringify(obj));
    this.selectedCollegeData = item;
    const isCoach = this.loginInfoProvider.module.toLowerCase() === 'coach';
    this.role = isCoach ? this._commonAuthService.getModule().toLowerCase() : this.role;
    this.router.navigate([`/${this.module}/collegeDetail`], { relativeTo: this.routes, queryParams: { id: item.collegeid } });

    localStorage.setItem('navigation', '/' + this.module + '/' + this.routes.snapshot.url[0].path);
  }

  checkDropdownsVisibility() {
    if (this.router.url !== '/student/myColleges') {
      this.sortedCollegeList = [];
    }
    this.isSenior = this._commonAuthService.isSenior() || this.studentClassYearDescription;
    this.showDropdowns = this.statusJsonList && this.statusJsonList.length > 0;
    this.sortedCollegeList = this.collegeJsonList;
    if (this.totalItems > 0) {
      this.pageShow = true;
    }
  }


  private nameSort(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  private rankSort(a, b) {
    return a.myFitRank - b.myFitRank;
  }


}

